export const SUBMITTING_LABEL = "Enviando...";
